/** Read/write the ?s=...&tab=... query string. Single source of truth
 *  inside the component; URL is just a serialisation target. */

export interface UrlState {
  query: string;
  tab: string;
}

export function readUrl(initialFromAttr?: { query?: string; tab?: string }): UrlState {
  if (typeof window === "undefined") {
    return { query: initialFromAttr?.query ?? "", tab: initialFromAttr?.tab ?? "all" };
  }
  const p = new URLSearchParams(window.location.search);
  return {
    query: p.get("s") ?? initialFromAttr?.query ?? "",
    tab: p.get("tab") ?? initialFromAttr?.tab ?? "all",
  };
}

export function writeUrl(state: UrlState): void {
  if (typeof window === "undefined") return;
  const p = new URLSearchParams(window.location.search);
  if (state.query) p.set("s", state.query);
  else p.delete("s");
  if (state.tab && state.tab !== "all") p.set("tab", state.tab);
  else p.delete("tab");
  p.delete("src"); // analytics handoff marker, read once on load
  const next = `${window.location.pathname}?${p.toString()}`.replace(/\?$/, "");
  window.history.replaceState(null, "", next);
}

export function debounce<T extends (...a: never[]) => void>(fn: T, ms: number): T {
  let h: ReturnType<typeof setTimeout> | null = null;
  return ((...args: never[]) => {
    if (h) clearTimeout(h);
    h = setTimeout(() => fn(...args), ms);
  }) as T;
}
